import { createFormatForDescription as cffd } from '../createFormatForDescription'
import MultiSignature from '../types/util/MultiSignature'

import { Explanation, explain } from './Explanation'

/**
 * Explains the contents of (a part of) a multi-signature.
 *
 * @property account - An explanation of the account.
 * @property txnSignature - An explanation of the signature.
 * @property signingPubKey - An explanation of the public key used in the multi-signature.
 */

export interface MultiSignatureExplanation {
  readonly account: Explanation<string>
  readonly txnSignature: Explanation<string>
  readonly signingPubKey: Explanation<string>
}

/**
 * Creates an explanation for one part of a multi-signature.
 *
 * @param sig - The part of the multi-signature to be explained.
 * @returns The explanation of the part of the multi-signature.
 */
export function createMultiSignatureExplanation(
  sig: MultiSignature,
): MultiSignatureExplanation {
  const account = explain(
    sig.Signer.Account,
    `One of the signers is account ${cffd(sig.Signer.Account, 'account')}`,
  )

  const txnSignature = explain(
    sig.Signer.TxnSignature,
    `The signature from this account was ${cffd(
      sig.Signer.TxnSignature,
      'txnSignature',
    )}`,
  )

  const signingPubKey = explain(
    sig.Signer.SigningPubKey,
    `The public key used in this signature was ${cffd(
      sig.Signer.SigningPubKey,
      'signingPubKey',
    )}`,
  )
  return {
    account,
    txnSignature,
    signingPubKey,
  }
}
